import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Permission } from "../../../interfaces/permission";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { PermissionService } from "../../../services/permission.service";
import { CentroCostoService } from "../../../services/centro-costo.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Response } from "../../../interfaces/response";
import { ICentroCosto } from 'src/app/interfaces/centro-costo';

@Component({
  selector: 'app-centro-costo-save',
  templateUrl: './centro-costo-save.component.html',
  styleUrls: ['./centro-costo-save.component.css']
})
export class CentroCostoSaveComponent implements OnInit {

  form: FormGroup;
  centroCosto: ICentroCosto;

  @Input() closeMyModal: (any) => void;
  @Input() orden_ceco: any;
  @Input() tipo: any;
  @Output() salida: EventEmitter<any> = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    private centroCostoService: CentroCostoService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      orden_ceco: ['', Validators.required],
      nombre_ceco: ['', Validators.required],
    });

    this.centroCostoService.get(this.orden_ceco)
      .subscribe(
        (res: Response) => {
          this.centroCosto = res.data;
          this.form.patchValue({
            orden_ceco: this.centroCosto.orden_ceco,
            nombre_ceco: this.centroCosto.nombre_ceco
          });
        },
        err => console.log('HTTP Error', err)
      );
  }

  submit() {

    const data = this.form.getRawValue();


    if (this.tipo == "edit") {
      // editar el registro
      this.centroCostoService.update(this.centroCosto.orden_ceco, data).subscribe(
        (res: Response) => {
          this.salida.emit(res);
        },
      )

    } else {
      // agregar el registro
      this.centroCostoService.create(data).subscribe(
        res => {
          this.salida.emit(res);
        }
      );
    }
  }


}
